import Axios from 'axios';
import i18next from 'i18next';

import {
	CLEAR_SELF_ERRORS,
	UPLOAD_FILE_ERROR,
	ALL_FILES_LOADING,
	ALL_FILES_GET,
	ALL_FILES_ERROR,
	FILE_INFO_LOADING,
	FILE_INFO_GET,
	FILE_INFO_ERROR,
	DOWNLOAD_FILE_LOADING,
	FILE_CHECK_LOADING,
	FILE_CHECK_GET,
	FILE_CHECK_ERROR,
	FILE_HISTORY_SET,
	DOWNLOAD_VALIDATION_LOADING,
	FILE_CONFIRM_LOADING,
	FILE_DISCARD_LOADING,
	LOAD_CREATE_LOADING,
	LOAD_CREATE_ERROR,
	ALL_LOADS_LOADING,
	ALL_LOADS_GET,
	ALL_LOADS_ERROR,
	CYCLE_LOADS_LOADING,
	CYCLE_LOADS_GET,
	CYCLE_LOADS_ERROR,
	LOAD_INFO_LOADING,
	LOAD_INFO_GET,
	LOAD_INFO_ERROR,
	LOAD_UPDATE_LOADING,
	LOAD_UPDATE_ERROR,
	LOAD_DELETE_LOADING,
	LOADS_DATA_LOADING,
	LOADS_DATA_GET,
	LOADS_DATA_ERROR,
	SET_SELECTED_NODE,
	SELF_MOVEMENTS_LOADING,
	SELF_MOVEMENTS_GET,
	SELF_MOVEMENTS_ERROR,
	SELF_MOVEMENTS_SUMMARY_LOADING,
	SELF_MOVEMENTS_SUMMARY_GET,
	SELF_MOVEMENTS_SUMMARY_ERROR,
	SELF_DISCARDS_LOADING,
	SELF_DISCARDS_GET,
	SELF_DISCARDS_ERROR,
	SELF_DISCARDS_SUMMARY_LOADING,
	SELF_DISCARDS_SUMMARY_GET,
	SELF_DISCARDS_SUMMARY_ERROR,
	DOWNLOAD_WEEKLY_REPORT_LOADING
} from '../types';

// Utils
import create_query_params from '../../utils/create_query_params';
import add_key_prop from '../../utils/add_key_prop';

export const clear_self_errors = () => dispatch => {
	dispatch({
		type: CLEAR_SELF_ERRORS
	});
}

export const estimate_file_time = (body = {}) => {
	return new Promise((resolve, reject) => {
		let url = process.env.REACT_APP_SERVER_URL + '/api/self/files/estimate';

		const formData = new FormData();
		formData.append('organization', body.organization);
		formData.append('workspace', body.workspace);
		formData.append('module', body.module);
		formData.append('type', body.type);
		formData.append('file', body.file);

		Axios.post(url, formData)
		.then((res) => {
			resolve(res.data);
		}).catch((err) => {
			console.error('Error estimating file time:', err);
			reject(err);
		});
	});
}

export const upload_file = (messageApi, body = {}) => dispatch => {
	dispatch(clear_self_errors());
	const hideLoadingMsg = messageApi.loading(i18next.t('loadFile.msg.loading'), 0);
	
	let url = process.env.REACT_APP_SERVER_URL + '/api/self/files/upload';

	const formData = new FormData();
	formData.append('organization', body.organization);
	formData.append('workspace', body.workspace);
	formData.append('module', body.module);
	if (body.cycle) {
		formData.append('cycle', body.cycle);
	}
	if (body.load) {
		formData.append('load', body.load);
	}
	formData.append('source', 2);
	formData.append('type', body.type);
	formData.append('name', body.name);
	formData.append('description', body.description);
	formData.append('file', body.file);

	Axios.post(url, formData)
	.then((res) => {
		hideLoadingMsg();
		messageApi.success(i18next.t('loadFile.msg.success'), 4, res.data);
	}).catch((err) => {
		// console.log(err);
		hideLoadingMsg();
		// messageApi.error(i18next.t('loadFile.msg.error'), 4);
		dispatch({
			type: UPLOAD_FILE_ERROR,
			payload: { type: 'upload_file', msg: err.response.data }
		});
	})
}

export const get_all_files = (filters) => dispatch => {
	dispatch({
		type: ALL_FILES_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/files?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		const newFilesArray = add_key_prop(res.data.data);
		res.data.files = newFilesArray;

		dispatch({
			type: ALL_FILES_GET,
			payload: res.data
		});

		dispatch({
			type: ALL_FILES_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_FILES_ERROR,
			payload: { type: 'all_files', msg: err.message }
		});

		dispatch({
			type: ALL_FILES_LOADING,
			payload: false
		});
	})
}

export const get_file_info = (file_id) => dispatch => {
	dispatch({
		type: FILE_INFO_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/info`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: FILE_INFO_GET,
			payload: res.data
		});

		dispatch({
			type: FILE_INFO_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: FILE_INFO_ERROR,
			payload: { type: 'file_info', msg: err.message }
		});

		dispatch({
			type: FILE_INFO_LOADING,
			payload: false
		});
	})
}

export const get_file_movements = (file_id, history_id = null) => {
	return new Promise((resolve, reject) => {
		let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/movements`;
		
		// Add history parameter if provided
		if (history_id) {
			url += `?history=${history_id}`;
		}

		Axios.get(url)
		.then((res) => {
			resolve(res.data);
		}).catch((err) => {
			console.error('Error getting file movements:', err);
			reject(err);
		});
	});
}

export const get_file_metrics = (file_id, history_id = null) => {
	return new Promise((resolve, reject) => {
		let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/metrics`;
		
		// Add history parameter if provided
		if (history_id) {
			url += `?history=${history_id}`;
		}

		Axios.get(url)
		.then((res) => {
			resolve(res.data);
		}).catch((err) => {
			console.error('Error getting file metrics:', err);
			reject(err);
		});
	});
}

export const download_file = (messageApi, file_id, fileName) => dispatch => {
	dispatch({
		type: DOWNLOAD_FILE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/data`;

	Axios.request({
		url: url,
		method: 'GET',
		responseType: 'blob',
	}).then((res) => {
		dispatch({
			type: DOWNLOAD_FILE_LOADING,
			payload: false
		});

		const downloadURL = window.URL.createObjectURL(new Blob([ res.data ]));
		const link = document.createElement('a');
		link.href = downloadURL;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.download.error'), 4);

		dispatch({
			type: DOWNLOAD_FILE_LOADING,
			payload: false
		});
	})
}

export const check_file = (showLoading, file_id) => dispatch => {
	if (showLoading) {
		dispatch({
			type: FILE_CHECK_LOADING,
			payload: true
		});
	}

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/check`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch(set_file_history(res.data.history));

		dispatch({
			type: FILE_CHECK_GET,
			payload: res.data
		});

		dispatch({
			type: FILE_CHECK_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: FILE_CHECK_ERROR,
			payload: { type: 'check_file', msg: err.message }
		});

		dispatch({
			type: FILE_CHECK_LOADING,
			payload: false
		});
	})
}

export const set_file_history = (histories) => dispatch => {
	const options = histories
		.sort((a, b) => b.date.$date - a.date.$date) // Sort by date
		.map(history => ({
			label: new Date(history?.date?.$date).toLocaleString(
				localStorage.getItem('i18nextLng'), 
				{ hour12: true }
			),
			value: history?._id?.$oid
		}));
	
	dispatch({
		type: FILE_HISTORY_SET,
		payload: {
			history_options: options,
			history_latest: options[0]?.value
		}
	});
}

export const download_validation_file = (messageApi, file_id, fileName) => dispatch => {
	dispatch({
		type: DOWNLOAD_VALIDATION_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/validation`;

	Axios.request({
		url: url,
		method: 'GET',
		responseType: 'blob',
	}).then((res) => {
		dispatch({
			type: DOWNLOAD_VALIDATION_LOADING,
			payload: false
		});

		const downloadURL = window.URL.createObjectURL(new Blob([ res.data ]));
		const link = document.createElement('a');
		link.href = downloadURL;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.download.error'), 4);

		dispatch({
			type: DOWNLOAD_VALIDATION_LOADING,
			payload: false
		});
	})
}

export const confirm_file = (messageApi, file_id) => dispatch => {
	dispatch({
		type: FILE_CONFIRM_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/confirm`;

	Axios.post(url)
	.then((res) => {
		// console.log(res.data);
		messageApi.success(i18next.t('loadStatusDetails.confirm.msg.success'), 4);

		dispatch({
			type: FILE_CONFIRM_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.confirm.msg.error'), 4);

		dispatch({
			type: FILE_CONFIRM_LOADING,
			payload: false
		});
	})
}

export const discard_file = (messageApi, file_id, filters) => dispatch => {
	dispatch({
		type: FILE_DISCARD_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/files/${file_id}/discard`;

	Axios.delete(url)
	.then((res) => {
		// console.log(res.data);
		messageApi.success(i18next.t('loadStatusDetails.discard.msg.success'), 4);

		dispatch({
			type: FILE_DISCARD_LOADING,
			payload: false
		});

		if (filters) {
			dispatch(get_all_files(filters));
		}
		else {
			dispatch(get_file_info(file_id));
		}
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.discard.msg.error'), 4);

		dispatch({
			type: FILE_DISCARD_LOADING,
			payload: false
		});
	})
}

export const load_create = (messageApi, loadInfo, handleCancel, filters, wizardSaveLoadId) => dispatch => {
	dispatch({
		type: LOAD_CREATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/loads/create`;
	
	const body = {
		...loadInfo,
		source: 2
	};

	Axios.post(url, body)
	.then((res) => {
		messageApi.success(i18next.t('loadForm.create.msg.success'), 4);

		wizardSaveLoadId(res.data.load);
		
		handleCancel();

		dispatch({
			type: LOAD_CREATE_LOADING,
			payload: false
		});

		dispatch(get_all_loads(filters));
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: LOAD_CREATE_ERROR,
			payload: { type: 'load_create', msg: err.message }
		});

		dispatch({
			type: LOAD_CREATE_LOADING,
			payload: false
		});
	})
}

export const get_all_loads = (filters) => dispatch => {
	dispatch({
		type: ALL_LOADS_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/loads?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		const newLoadsArray = add_key_prop(res.data.data);
		res.data.loads = newLoadsArray;

		dispatch({
			type: ALL_LOADS_GET,
			payload: res.data
		});

		dispatch({
			type: ALL_LOADS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_LOADS_ERROR,
			payload: { type: 'all_loads', msg: err.message }
		});

		dispatch({
			type: ALL_LOADS_LOADING,
			payload: false
		});
	})
}

export const get_cycle_loads = (cycleId) => dispatch => {
	dispatch({
		type: CYCLE_LOADS_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/loads?cycle=${cycleId}`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: CYCLE_LOADS_GET,
			payload: res.data
		});

		dispatch({
			type: CYCLE_LOADS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: CYCLE_LOADS_ERROR,
			payload: { type: 'cycle_loads', msg: err.message }
		});

		dispatch({
			type: CYCLE_LOADS_LOADING,
			payload: false
		});
	})
}

export const get_load_info = (loadId) => dispatch => {
	dispatch({
		type: LOAD_INFO_LOADING,
		payload: true
	});

	const url = `${process.env.REACT_APP_SERVER_URL}/api/self/loads/${loadId}/info`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: LOAD_INFO_GET,
			payload: res.data
		});

		dispatch({
			type: LOAD_INFO_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: LOAD_INFO_ERROR,
			payload: { type: 'get_load_info', msg: err.message }
		});

		dispatch({
			type: LOAD_INFO_LOADING,
			payload: false
		});
	})
}

export const load_update = (messageApi, loadId, loadInfo, handleCancel, filters) => dispatch => {
	dispatch({
		type: LOAD_UPDATE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/loads/${loadId}/update`;

	Axios.put(url, loadInfo)
	.then((res) => {
		messageApi.success(i18next.t('loadForm.edit.msg.success'), 4);
		
		handleCancel();

		dispatch({
			type: LOAD_UPDATE_LOADING,
			payload: false
		});

		dispatch(get_all_loads(filters));
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: LOAD_UPDATE_ERROR,
			payload: { type: 'load_update', msg: err.message }
		});

		dispatch({
			type: LOAD_UPDATE_LOADING,
			payload: false
		});
	})
}

export const load_delete = (messageApi, loadId, filters) => dispatch => {
	dispatch({
		type: LOAD_DELETE_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/self/loads/${loadId}/remove`;

	Axios.delete(url)
	.then((res) => {
		messageApi.success(i18next.t('loadForm.delete.msg.success'), 4);

		dispatch({
			type: LOAD_DELETE_LOADING,
			payload: false
		});

		dispatch(get_all_loads(filters));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadForm.delete.msg.error'), 4);

		dispatch({
			type: LOAD_DELETE_LOADING,
			payload: false
		});
	})
}

export const get_loads_data = (filters) => dispatch => {
	dispatch({
		type: LOADS_DATA_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + '/api/self/loads/data?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		dispatch({
			type: LOADS_DATA_GET,
			payload: res.data
		});

		dispatch({
			type: LOADS_DATA_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: LOADS_DATA_ERROR,
			payload: { type: 'loads_data', msg: err.message }
		});

		dispatch({
			type: LOADS_DATA_LOADING,
			payload: false
		});
	})
}

export const file_check_retry = (messageApi, file_info) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/self/files/check';

	const body = {
		organization: file_info.organization._id.$oid,
		file: file_info._id.$oid
	}

	Axios.post(url, body)
	.then((res) => {
		// console.log(res.data);
		messageApi.success('Checking file', 4);
		dispatch(get_file_info(file_info._id.$oid));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(err.message, 4);
	})
}

export const file_process = (messageApi, file_id) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/self/files/process';

	const body = {
		file: file_id
	}

	Axios.post(url, body)
	.then((res) => {
		// console.log(res.data);
		messageApi.success(i18next.t('loadStatusDetails.process.successSingle'), 4);
		dispatch(get_file_info(file_id));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.process.errorSingle'), 4);
	})
}

export const load_files_process = (messageApi, loadId) => dispatch => {
	const url = `${process.env.REACT_APP_SERVER_URL}/api/self/loads/process`;

	const body = {
		load: loadId
	}

	Axios.post(url, body)
	.then((res) => {
		// console.log(res.data);
		messageApi.success(i18next.t('loadStatusDetails.process.successMultiple'), 4);
		dispatch(get_load_info(loadId));
		dispatch(get_all_files({ load: loadId }));
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.process.errorMultiple'), 4);
	})
}

export const load_self = (onSuccess, onError) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/manager/load/self';

	Axios.get(url)
	.then((res) => {
		// console.log(res.data);
		if (onSuccess) {
			onSuccess();
		}
	}).catch((err) => {
		// console.log(err);
		if (onError) {
			onError();
		}
	})
}

export const set_selected_node = (node) => dispatch => {
	dispatch({
		type: SET_SELECTED_NODE,
		payload: node
	});
}

// Get self movements with pagination and filters
export const get_self_movements = (filters = {}) => dispatch => {
	dispatch({
		type: SELF_MOVEMENTS_LOADING
	});

	const params = {
		skip: filters.skip || 0,
		limit: filters.limit || 100,
		...(filters.load_history && { history: filters.load_history }),
		...(filters.organization && { organization: filters.organization }),
		...(filters.location_code && { location_code: filters.location_code }),
		...(filters.movement_type && { movement_type: filters.movement_type })
	};

	const queryString = create_query_params(params);
	const url = process.env.REACT_APP_SERVER_URL + '/api/self/movements?' + queryString;

	Axios.get(url)
		.then(res => {
			dispatch({
				type: SELF_MOVEMENTS_GET,
				payload: res.data
			});
		})
		.catch(err => {
			// console.error('Error fetching movements:', err);
			dispatch({
				type: SELF_MOVEMENTS_ERROR,
				payload: err.response?.data || { message: 'Error fetching movements' }
			});
		});
}

// Get movements summary for a specific history
export const get_self_movements_summary = (historyId) => dispatch => {
	dispatch({
		type: SELF_MOVEMENTS_SUMMARY_LOADING
	});

	const url = process.env.REACT_APP_SERVER_URL + `/api/self/movements/summary?history=${historyId}`;

	Axios.get(url)
		.then(res => {
			dispatch({
				type: SELF_MOVEMENTS_SUMMARY_GET,
				payload: res.data
			});
		})
		.catch(err => {
			// console.error('Error fetching movements summary:', err);
			dispatch({
				type: SELF_MOVEMENTS_SUMMARY_ERROR,
				payload: err.response?.data || { message: 'Error fetching movements summary' }
			});
		});
}

// Get discards with pagination and filters
export const get_self_discards = (filters = {}) => dispatch => {
	dispatch({
		type: SELF_DISCARDS_LOADING
	});

	const params = {
		skip: filters.skip || 0,
		limit: filters.limit || 100,
		...(filters.load_history && { history: filters.load_history }),
		...(filters.organization && { organization: filters.organization }),
		...(filters.location_code && { location_code: filters.location_code }),
		...(filters.discard_reason && { discard_reason: filters.discard_reason })
	};

	const queryString = create_query_params(params);
	const url = process.env.REACT_APP_SERVER_URL + '/api/self/discards?' + queryString;

	Axios.get(url)
		.then(res => {
			dispatch({
				type: SELF_DISCARDS_GET,
				payload: res.data
			});
		})
		.catch(err => {
			// console.error('Error fetching discards:', err);
			dispatch({
				type: SELF_DISCARDS_ERROR,
				payload: err.response?.data || { message: 'Error fetching discards' }
			});
		});
}

// Get discards summary for a specific history
export const get_self_discards_summary = (historyId) => dispatch => {
	dispatch({
		type: SELF_DISCARDS_SUMMARY_LOADING
	});

	const url = process.env.REACT_APP_SERVER_URL + `/api/self/discards/summary?history=${historyId}`;

	Axios.get(url)
		.then(res => {
			dispatch({
				type: SELF_DISCARDS_SUMMARY_GET,
				payload: res.data
			});
		})
		.catch(err => {
			// console.error('Error fetching discards summary:', err);
			dispatch({
				type: SELF_DISCARDS_SUMMARY_ERROR,
				payload: err.response?.data || { message: 'Error fetching discards summary' }
			});
		});
}
// Download weekly report
export const download_weekly_report = (messageApi, params, fileName, extraBody = {}) => dispatch => {
	dispatch({
		type: DOWNLOAD_WEEKLY_REPORT_LOADING,
		payload: true
	});

	const url = process.env.REACT_APP_SERVER_URL + '/api/reports/weekly';

	Axios.request({
		url: url,
		method: 'POST',
		responseType: 'blob',
		data: { ...params, ...extraBody }
	}).then((res) => {
		dispatch({
			type: DOWNLOAD_WEEKLY_REPORT_LOADING,
			payload: false
		});

		const downloadURL = window.URL.createObjectURL(new Blob([ res.data ]));
		const link = document.createElement('a');
		link.href = downloadURL;
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}).catch((err) => {
		// console.log(err);
		messageApi.error(i18next.t('loadStatusDetails.download.error'), 4);

		dispatch({
			type: DOWNLOAD_WEEKLY_REPORT_LOADING,
			payload: false
		});
	})
}
